var ils;
(function (ils) {
    var showcaseListings;
    (function (showcaseListings) {
        showcaseListings.markers = [];
        showcaseListings.bounds = new google.maps.LatLngBounds();
        ;
        showcaseListings.polygon = null;
        showcaseListings.isDrawing = false;
        function SetPolygonCoordinates(latLngArray) {
            if (latLngArray.length <= 2) {
                if (showcaseListings.polygon)
                    showcaseListings.polygon.setMap(null);
                if (showcaseListings.polyline)
                    showcaseListings.polyline.setMap(null);
                ils.showcaseListings.viewModel.PolygonCoordinates("");
                return;
            }
            var latLngs = '';
            for (var i = 0; i < latLngArray.length; i++) {
                latLngs += latLngArray.getAt(i).lat() + ' ' + latLngArray.getAt(i).lng() + ', ';
            }
            if (latLngArray.getAt(0).lat() != latLngArray.getAt(latLngArray.length - 1).lat() || latLngArray.getAt(0).lng() != latLngArray.getAt(latLngArray.length - 1).lng())
                latLngs += latLngArray.getAt(0).lat() + ' ' + latLngArray.getAt(0).lng();
            else
                latLngs = latLngs.replace(/,\s$/, "");
            showcaseListings.viewModel.PolygonCoordinates(latLngs);
        }
        showcaseListings.SetPolygonCoordinates = SetPolygonCoordinates;
        function setMapZoom(maxZoomLevel) {
            if (showcaseListings.map.customMarker || $('#map_canvas').is(":visible")) {
                if (showcaseListings.map.getZoom() > maxZoomLevel)
                    showcaseListings.map.setZoom(maxZoomLevel);
                if (showcaseListings.counter < 4 && showcaseListings.map.getZoom() != maxZoomLevel) {
                    showcaseListings.counter++;
                    setTimeout(function () { setMapZoom(maxZoomLevel); }, 1000);
                }
            }
        }
        showcaseListings.setMapZoom = setMapZoom;
        function createPhoneNumberHtml(phone, isPayPerClick) {
            if (isPayPerClick) {
                return '';
            }
            return `<span class="phone"><span class="ilsicon ilsicon-phone"></span>&nbsp;${showcaseListings.FormatPhone(phone)}</span>`;
        }
        showcaseListings.createPhoneNumberHtml = createPhoneNumberHtml;
        function showInfoWindow(markerIndex, smoothPanning) {
            var infoBoxOptions = {
                boxStyle: {
                    background: "#fff",
                    width: breakpoint() === "mobile" ? "200px" : "250px",
                    border: "3px solid " + brandColorPrimary,
                    'border-radius': "5px"
                },
                closeBoxURL: imageDomain + 'img/close.png?width=50&v=1',
                closeBoxMargin: "-12px -14px 0 0",
                pixelOffset: new google.maps.Size((breakpoint() === "mobile" ? -100 : -115), (breakpoint() === "mobile" ? -140 : -165)),
                disableAutoPan: smoothPanning
            };
            var doOpen = false;
            if (showcaseListings.markers[markerIndex]) {
                if (!showcaseListings.infoBox || showcaseListings.infoBox["content_"] !== showcaseListings.markers[markerIndex].html) {
                    if (showcaseListings.infoBox)
                        showcaseListings.infoBox.setOptions($.extend({}, infoBoxOptions, { content: showcaseListings.markers[markerIndex].html }));
                    else
                        showcaseListings.infoBox = new InfoBox($.extend({}, infoBoxOptions, { content: showcaseListings.markers[markerIndex].html }));
                    doOpen = true;
                }
                else if (showcaseListings.infoBox["content"] === showcaseListings.markers[markerIndex].html && !showcaseListings.infoBox["map"])
                    doOpen = true;
            }
            if (doOpen) {
                if (smoothPanning) {
                    var latLng = showcaseListings.markers[markerIndex].getPosition();
                    //Now center ils.map slowly
                    var currentZoom = showcaseListings.map["zoom"];
                    showcaseListings.map.panTo(latLng);
                    // We're wrapping this up in a timeout because there were issues with Google maps panning way off into the Atlantic ocean
                    // when you were zoomed in
                    var timeout = setTimeout(function () {
                        showcaseListings.map.setZoom(currentZoom);
                        showcaseListings.map.panTo(latLng);
                        clearTimeout(timeout);
                        timeout = undefined;
                    }, 200);
                }
                if (!showcaseListings.infoBox) {
                    showcaseListings.infoBox = new InfoBox($.extend({}, infoBoxOptions, { content: showcaseListings.markers[markerIndex].html }));
                }
                showcaseListings.infoBox.open(showcaseListings.map, showcaseListings.markers[markerIndex]);
            }
        }
        showcaseListings.showInfoWindow = showInfoWindow;
        function createMarker(showcaseItem, latlng, isLastAddress, icon = null, isFeaturedIcon = false) {
            const markerIndex = showcaseListings.markers.length;
            const imageForRetina = new google.maps.MarkerImage(icon, null, null, null, new google.maps.Size(38, 61));
            const markerOptions = { position: latlng, map: showcaseListings.map, icon: imageForRetina };
            const marker = new google.maps.Marker(markerOptions);
            marker.IsFeaturedIcon = isFeaturedIcon;
            if (!showcaseListings.map.customMarker) {
                marker.html = [
                    '<div class="map-marker">',
                    `<img class="photo img-responsive" alt="${showcaseItem.Title}" src="${showcaseListings.GetImage(showcaseItem.Image, showcaseItem.ABTestImage, "?preset=community-map")}" />`,
                    `<a class="community name${showcaseItem.Title.length >= 17 ? showcaseItem.Title.length >= 20 ? ' longer' : ' long' : ''}" onclick="return ils.showcaseListings.mapMarkerClick('${showcaseItem.DetailsPageUrl}');" target="_blank" href="${showcaseItem.DetailsPageUrl}">${showcaseItem.Title}</a>`,
                    createPhoneNumberHtml(showcaseItem.Phone, showcaseItem.IsPayPerClick),
                    `<a class="btn btn-sm btn-secondary community" onclick="return ils.showcaseListings.mapMarkerClick('${showcaseItem.DetailsPageUrl}');" target="_blank" href="${showcaseItem.DetailsPageUrl}">Learn More <span class="ilsicon ilsicon-arrow-right"></span></a>`,
                    '</div>',
                    '<div class="background-shadow"></div>'
                ].join('');
                google.maps.event.addListener(marker, "click", function () {
                    showInfoWindow(markerIndex, true);
                });
            }
            return marker;
        }
        showcaseListings.createMarker = createMarker;
        function ClusterMarkers() {
            var markersToCluster = showcaseListings.markers.filter(function (item) { return !item.IsFeaturedIcon; });
            if (clusterMarkers) {
                showcaseListings.markerClusterer = new MarkerClusterer(showcaseListings.map, markersToCluster, {
                    styles: [
                        {
                            url: imageDomain + 'img/map-cluster.png?v=1',
                            height: 38,
                            width: 38,
                            textSize: 20,
                            textColor: '#fff'
                        }
                    ],
                    minimumClusterSize: clusterQuantity
                });
            }
        }
        showcaseListings.ClusterMarkers = ClusterMarkers;
        function AddMarkerAndExpandBounds(latlng, showcaseItem, isLastAddress, markerImage, currentIndex = 0) {
            currentIndex = !currentIndex || currentIndex <= 0 ? showcaseListings.markers.length : currentIndex;
            showcaseListings.markers[currentIndex] = createMarker(showcaseItem, latlng, isLastAddress, markerImage, showcaseItem.IsFeaturedIcon);
            if (!showcaseListings.bounds) {
                showcaseListings.bounds = new google.maps.LatLngBounds();
            }
            showcaseListings.bounds.extend(showcaseListings.markers[showcaseListings.markers.length - 1].position);
            if (isLastAddress) {
                if (showcaseListings.addressMarker)
                    showcaseListings.bounds.extend(showcaseListings.addressMarker.getPosition());
                showcaseListings.map.fitBounds(showcaseListings.bounds);
                setTimeout(function () {
                    setMapZoom(17);
                    ClusterMarkers();
                }, 100);
            }
        }
        showcaseListings.AddMarkerAndExpandBounds = AddMarkerAndExpandBounds;
        function AddPlaceholderMarker(showcaseItem, isLastAddress, markerImage, currentIndex) {
            currentIndex = !currentIndex || currentIndex <= 0 ? showcaseListings.markers.length : currentIndex;
            var latlng = new google.maps.LatLng(1.0, 1.0);
            showcaseListings.markers[currentIndex] = createMarker(showcaseItem, latlng, isLastAddress, markerImage, showcaseItem.IsFeaturedIcon);
        }
        showcaseListings.AddPlaceholderMarker = AddPlaceholderMarker;
        showcaseListings.geocodingMarkerCount = 0;
        function codeAddress(showcaseItem, isLastAddress) {
            if (showcaseListings.geocoder) {
                var currentIndex = showcaseListings.markers.length;
                if (showcaseItem != null) {
                    var markerImage = showcaseListings.map["customMarker"]
                        ? imageDomain + "img/map-marker-" + (showcaseListings.markers.length + 1 + showcaseListings.geocodingMarkerCount) + ".png"
                        : showcaseItem.IsFeaturedIcon
                            ? imageDomain + 'img/map-marker-featured.png?v=1'
                            : imageDomain + 'img/map-marker.png?v=1';
                    if (showcaseItem.CorrectedGeocodedLat && showcaseItem.CorrectedGeocodedLong)
                        AddMarkerAndExpandBounds(new google.maps.LatLng(showcaseItem.CorrectedGeocodedLat, showcaseItem.CorrectedGeocodedLong), showcaseItem, isLastAddress, markerImage);
                    else if (showcaseItem.GeocodedLat && showcaseItem.GeocodedLong)
                        AddMarkerAndExpandBounds(new google.maps.LatLng(showcaseItem.GeocodedLat, showcaseItem.GeocodedLong), showcaseItem, isLastAddress, markerImage);
                    else {
                        showcaseListings.geocodingMarkerCount++;
                        AddPlaceholderMarker(showcaseItem, isLastAddress, markerImage, currentIndex);
                        var address = $.trim((showcaseItem.Address + " " + showcaseItem.City + " FL " + showcaseItem.Zipcode).replace(/null/g, ""));
                        if (address !== "") {
                            showcaseListings.geocoder.geocode({ 'address': address }, function (results, status) {
                                if (status === google.maps.GeocoderStatus.OK)
                                    AddMarkerAndExpandBounds(results[0].geometry.location, showcaseItem, true, markerImage, currentIndex);
                                showcaseListings.geocodingMarkerCount--;
                            });
                        }
                    }
                }
            }
        }
        showcaseListings.codeAddress = codeAddress;
        function clearMarkers() {
            for (var i = 0; i < showcaseListings.markers.length; i++) {
                showcaseListings.markers[i].setMap(null);
            }
            showcaseListings.markers = [];
            if (showcaseListings.markerClusterer)
                showcaseListings.markerClusterer.clearMarkers();
            showcaseListings.bounds = new google.maps.LatLngBounds();
            if (showcaseListings.infoBox)
                showcaseListings.infoBox.close();
        }
        showcaseListings.clearMarkers = clearMarkers;
        function SetUserAddress() {
            if (showcaseListings.addressMarker)
                showcaseListings.addressMarker.setMap(null);
            if (showcaseListings.viewModel.AddressText() != '') {
                var addr = showcaseListings.viewModel.AddressText();
                var ufReplacements = ["uf", "university of florida", "u of f"];
                if (ufReplacements.indexOf(addr.toLowerCase()) >= 0)
                    addr = "uf 32611";
                else if (addr.toLowerCase().indexOf(cityName.toLowerCase()) == -1)
                    addr += ' ' + cityName;
                showcaseListings.geocoder.geocode({ 'address': addr }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var imageForRetina = new google.maps.MarkerImage(baseUrl + "img/address-marker.png?v=1", null, null, null, new google.maps.Size(38, 57));
                        showcaseListings.addressMarker = new google.maps.Marker({
                            position: results[0].geometry.location,
                            map: showcaseListings.map,
                            icon: imageForRetina
                        });
                        var infoBoxOptions = {
                            boxClass: 'infoBox address-info-box',
                            pixelOffset: new google.maps.Size(-75, -50),
                            closeBoxURL: imageDomain + 'img/close.png?width=50&v=1',
                            closeBoxMargin: "-12px -14px 0 0",
                        };
                        showcaseListings.addressInfoBox = new InfoBox($.extend({}, infoBoxOptions, { content: showcaseListings.viewModel.AddressText() }));
                        if (showcaseListings.bounds) {
                            showcaseListings.bounds.extend(showcaseListings.addressMarker.getPosition());
                            if (showcaseListings.map.customMarker || $('#map_canvas').is(":visible")) {
                                showcaseListings.map.fitBounds(showcaseListings.bounds);
                                setTimeout(function () { setMapZoom(17); }, 100);
                            }
                        }
                        google.maps.event.addListener(showcaseListings.addressMarker, "click", function () {
                            showcaseListings.addressInfoBox.open(showcaseListings.map, showcaseListings.addressMarker);
                        });
                        showcaseListings.viewModel.ReadyToLoadData(false);
                        showcaseListings.viewModel.AddressLat(results[0].geometry.location.lat().toString());
                        showcaseListings.viewModel.AddressLong(results[0].geometry.location.lng().toString());
                        showcaseListings.viewModel.ReadyToLoadData(true);
                    }
                });
            }
            else {
                if (showcaseListings.bounds) {
                    showcaseListings.bounds = new google.maps.LatLngBounds();
                    showcaseListings.addressMarker = null;
                    if (showcaseListings.addressInfoBox)
                        showcaseListings.addressInfoBox.close();
                }
                showcaseListings.viewModel.ReadyToLoadData(false);
                showcaseListings.viewModel.AddressLat(null);
                showcaseListings.viewModel.AddressLong(null);
                showcaseListings.viewModel.ReadyToLoadData(true);
            }
        }
        showcaseListings.SetUserAddress = SetUserAddress;
        function mapMarkerClick(href) {
            if (!href && breakpoint() != "mobile")
                return false;
            else if (!href) {
                return true;
            }
            $(`.communities a[href$='${href}']`).trigger('click');
            if (breakpoint() != "mobile")
                return false;
            return true;
        }
        showcaseListings.mapMarkerClick = mapMarkerClick;
        function FormatFloorPlanTypesForMarker(types) {
            if (!types || types == '')
                return types;
            var typeArray = types.split(',');
            var consecutive = true;
            for (var i = 1; i < typeArray.length; i++) {
                if (parseInt(typeArray[i]) != (parseInt(typeArray[i - 1]) + 1))
                    consecutive = false;
            }
            return (consecutive
                ? (typeArray[0] == typeArray[typeArray.length - 1] ? (parseInt(typeArray[0]) == 0 ? "Studio" : `${typeArray[0]} BR`) : `${parseInt(typeArray[0]) == 0 ? "Studio" : typeArray[0]} to ${typeArray[typeArray.length - 1]} BR`)
                : `${types.replace(/,/g, ", ").replace(/,([^,]*)$/, ' and $1')} BR`);
        }
        showcaseListings.FormatFloorPlanTypesForMarker = FormatFloorPlanTypesForMarker;
        function initializeMap() {
            try {
                showcaseListings.geocoder = new google.maps.Geocoder();
                ils.mapCenter = new google.maps.LatLng(neighborhoodMapCenterKey, neighborhoodMapCenterValue);
                var myOptions = {
                    center: ils.mapCenter,
                    zoom: 17,
                    disableDefaultUI: true,
                    fullScreenControl: true,
                    cameraControl: true,
                    mapTypeControlOptions: {
                        position: google.maps.ControlPosition.TOP_RIGHT
                    }
                };
                showcaseListings.map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
                const polygonOpts = {
                    editable: true,
                    strokeColor: brandColorPrimary,
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: brandColorSecondary,
                    fillOpacity: 0.2
                };
                showcaseListings.drawingManager = new google.maps.drawing.DrawingManager({
                    drawingControl: false,
                    drawingControlOptions: {
                        drawingModes: [
                            google.maps.drawing.OverlayType.POLYGON
                        ]
                    },
                    polygonOptions: polygonOpts
                });
                showcaseListings.drawingManager.setMap(showcaseListings.map);
                google.maps.event.addListener(showcaseListings.drawingManager, 'polygoncomplete', function (event) {
                    if (showcaseListings.polygon)
                        showcaseListings.polygon.setMap(null);
                    if (showcaseListings.polyline)
                        showcaseListings.polyline.setMap(null);
                    showcaseListings.polygon = event;
                    SetPolygonCoordinates(showcaseListings.polygon.getPath());
                    showcaseListings.viewModel.MapMode(null);
                });
                if (polygonCoordinates && polygonCoordinates != '') {
                    var decodedCoords = google.maps.geometry.encoding.decodePath(polygonCoordinates);
                    showcaseListings.polygon = new google.maps.Polygon($.extend({}, {
                        paths: decodedCoords,
                        map: showcaseListings.map
                    }, polygonOpts));
                    SetPolygonCoordinates(showcaseListings.polygon.getPath());
                    if (hidePolygon)
                        showcaseListings.polygon.setMap(null);
                }
                if (showcaseListings.viewModel.AddressText())
                    SetUserAddress();
                else if (showcaseListings.viewModel && showcaseListings.viewModel.ReadyToLoadData)
                    showcaseListings.viewModel.ReadyToLoadData(true);
                var mouseMoveHandler = null;
                var polyLineHandler = null;
                google.maps.event.addListener(showcaseListings.map, 'mousedown', function () {
                    if (showcaseListings.viewModel.MapMode() !== 'freeform')
                        return true;
                    showcaseListings.isDrawing = !showcaseListings.isDrawing;
                    if (showcaseListings.isDrawing) {
                        if (showcaseListings.polyline)
                            showcaseListings.polyline.setMap(null);
                        showcaseListings.polyline = new google.maps.Polyline({
                            map: showcaseListings.map,
                            strokeColor: brandColorPrimary,
                            strokeOpacity: 0.8,
                            strokeWeight: 2
                        });
                        mouseMoveHandler = google.maps.event.addListener(showcaseListings.map, 'mousemove', function (e) {
                            if (!showcaseListings.isDrawing)
                                return false;
                            showcaseListings.polyline.getPath().push(e.latLng);
                        });
                        polyLineHandler = google.maps.event.addListener(showcaseListings.polyline, 'mouseup', function (event) {
                            EndDrawing();
                        });
                    }
                    else
                        EndDrawing();
                    showcaseListings.bounds = new google.maps.LatLngBounds();
                    function EndDrawing() {
                        google.maps.event.removeListener(mouseMoveHandler);
                        google.maps.event.removeListener(polyLineHandler);
                        var latLngArray = showcaseListings.polyline.getPath();
                        if (latLngArray.getLength() > 2 && (latLngArray.getAt(0).lat() != latLngArray.getAt(latLngArray.getLength() - 1).lat() || latLngArray.getAt(0).lng() != latLngArray.getAt(latLngArray.getLength() - 1).lng()))
                            showcaseListings.polyline.getPath().push(latLngArray.getAt(0));
                        if (showcaseListings.polygon)
                            showcaseListings.polygon.setMap(null);
                        SetPolygonCoordinates(showcaseListings.polyline.getPath());
                        showcaseListings.isDrawing = false;
                        showcaseListings.viewModel.MapMode(null);
                    }
                });
                ils.trackGoogleMapsEvent(ils.MapsGACategories.DynamicMaps, 'load', 'Showcase Map', 0.007);
            }
            catch (error) {
                console.error(error);
            }
        }
        showcaseListings.initializeMap = initializeMap;
        function MapResized() {
            if (showcaseListings.map) {
                var center = showcaseListings.map.getCenter();
                google.maps.event.trigger(showcaseListings.map, "resize");
                showcaseListings.map.panTo(center);
            }
        }
        showcaseListings.MapResized = MapResized;
        document.addEventListener('DOMContentLoaded', function () {
            var initMapTimeout = setTimeout(() => {
                initializeMap();
                clearTimeout(initMapTimeout);
            }, 1000);
            $(".map-tools .instructions").on('click', function () {
                $(".map-tools .drawing-help").slideToggle();
                return false;
            });
        });
    })(showcaseListings = ils.showcaseListings || (ils.showcaseListings = {}));
})(ils || (ils = {}));
